import { c as _c } from "react-compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation } from "@tanstack/react-query";
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import type { CaptureVisitorConsentRequest, ProblemDetails } from "../model";
import { retrieveData } from "../../custom-fetch";
import type { ErrorType, BodyType } from "../../custom-fetch";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
export const getCaptureVisitorConsentUrl = () => {
  return `https://admin.ageless.ai/api/v1/ageless/visitor-consent`;
};

/**
 * @summary Records a visitor's cookie/analytics consent decision, opening their consent record on first
contact. All four scopes are recorded as explicit grants or explicit denials.


Public and unauthenticated by necessity — the decision is made before any person exists, and
minting one to hang the decision on would let crawlers create phantom aggregates. Three
things keep that honest: the visitor id must be a canonical UUID, the request is rate
limited per source address, and known crawlers are accepted and discarded rather than
recorded. Nothing here identifies a person, and nothing about the caller is logged.
Repeating an unchanged decision is safe and cheap: the consent listener re-reports current
state on every page load, and the handler appends no event when nothing changed.
 */
export const captureVisitorConsent = async (captureVisitorConsentRequest?: CaptureVisitorConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureVisitorConsentUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureVisitorConsentRequest)
  });
};
export const getCaptureVisitorConsentMutationKey = () => ["captureVisitorConsent"] as const;
export const getCaptureVisitorConsentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureVisitorConsent>>, TError, CaptureVisitorConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureVisitorConsent>>, TError, CaptureVisitorConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureVisitorConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureVisitorConsent>>, CaptureVisitorConsentMutationVariables> = props => {
    const {
      data
    } = props ?? {};
    return captureVisitorConsent(data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureVisitorConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureVisitorConsent>>>;
export type CaptureVisitorConsentMutationBody = BodyType<CaptureVisitorConsentRequest> | undefined;
export type CaptureVisitorConsentMutationError = ErrorType<ProblemDetails>;
export type CaptureVisitorConsentMutationVariables = {
  data?: BodyType<CaptureVisitorConsentRequest>;
};

/**
 * @summary Records a visitor's cookie/analytics consent decision, opening their consent record on first
contact. All four scopes are recorded as explicit grants or explicit denials.


Public and unauthenticated by necessity — the decision is made before any person exists, and
minting one to hang the decision on would let crawlers create phantom aggregates. Three
things keep that honest: the visitor id must be a canonical UUID, the request is rate
limited per source address, and known crawlers are accepted and discarded rather than
recorded. Nothing here identifies a person, and nothing about the caller is logged.
Repeating an unchanged decision is safe and cheap: the consent listener re-reports current
state on every page load, and the handler appends no event when nothing changed.
 */
export const useCaptureVisitorConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureVisitorConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};